/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EprescriptionCancelSchema } from '../models/EprescriptionCancelSchema';
import type { EprescriptionConfigCheckSchema } from '../models/EprescriptionConfigCheckSchema';
import type { EprescriptionConfigCheckSubmitSchema } from '../models/EprescriptionConfigCheckSubmitSchema';
import type { EprescriptionConfigSignRequestSchema } from '../models/EprescriptionConfigSignRequestSchema';
import type { EprescriptionCreateSchema } from '../models/EprescriptionCreateSchema';
import type { EprescriptionDetailSchema } from '../models/EprescriptionDetailSchema';
import type { EprescriptionDraftSchema } from '../models/EprescriptionDraftSchema';
import type { EprescriptionPingSchema } from '../models/EprescriptionPingSchema';
import type { EprescriptionStatus } from '../models/EprescriptionStatus';
import type { PagedEprescriptionDetailSchema } from '../models/PagedEprescriptionDetailSchema';
import type { SignSubmitSchema } from '../models/SignSubmitSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EprescriptionsApi {
    /**
     * Create Eprescription
     * Create an eprescription draft and return the signing material. Required Permission: create_eprescription
     * @returns EprescriptionDraftSchema Created
     * @throws ApiError
     */
    public static eprescriptionCreateEprescriptionPost({
        requestBody,
    }: {
        requestBody: EprescriptionCreateSchema,
    }): CancelablePromise<EprescriptionDraftSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/eprescriptions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Eprescription List
     * List eprescriptions. Required Permission: get_eprescription_list
     * @returns PagedEprescriptionDetailSchema OK
     * @throws ApiError
     */
    public static eprescriptionGetEprescriptionListGet({
        patientId,
        status,
        limit = 100,
        offset,
    }: {
        patientId?: (string | null),
        status?: (EprescriptionStatus | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedEprescriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/eprescriptions/',
            query: {
                'patient_id': patientId,
                'status': status,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Eprescription Configuration
     * Build the AppPingZEP sign-request to verify the doctor's certificate. Required Permission: verify_eprescription_config
     * @returns EprescriptionConfigSignRequestSchema OK
     * @throws ApiError
     */
    public static eprescriptionGetEprescriptionConfigurationGet(): CancelablePromise<EprescriptionConfigSignRequestSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/eprescriptions/configuration/sign-request/',
        });
    }
    /**
     * Check Eprescription Configuration
     * Verify the eprescription configuration via a client-signed AppPingZEP. Required Permission: verify_eprescription_config
     * @returns EprescriptionConfigCheckSchema OK
     * @throws ApiError
     */
    public static eprescriptionCheckEprescriptionConfigurationPost({
        requestBody,
    }: {
        requestBody: EprescriptionConfigCheckSubmitSchema,
    }): CancelablePromise<EprescriptionConfigCheckSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/eprescriptions/configuration/checks/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Ping Eprescription
     * Verify connectivity to the SÚKL eprescription system via AppPing. Required Permission: verify_eprescription_config
     * @returns EprescriptionPingSchema OK
     * @throws ApiError
     */
    public static eprescriptionPingEprescriptionGet(): CancelablePromise<EprescriptionPingSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/eprescriptions/ping/',
        });
    }
    /**
     * Set Eprescription Signature
     * Attach the client-produced signature to the eprescription and send it to SÚKL. Required Permission: sign_eprescription
     * @returns EprescriptionDetailSchema OK
     * @throws ApiError
     */
    public static eprescriptionSetEprescriptionSignaturePut({
        eprescriptionId,
        requestBody,
    }: {
        eprescriptionId: string,
        requestBody: SignSubmitSchema,
    }): CancelablePromise<EprescriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/eprescriptions/{eprescription_id}/signature/',
            path: {
                'eprescription_id': eprescriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Eprescription
     * Get eprescription detail. Required Permission: get_eprescription_detail
     * @returns EprescriptionDetailSchema OK
     * @throws ApiError
     */
    public static eprescriptionGetEprescriptionGet({
        eprescriptionId,
    }: {
        eprescriptionId: string,
    }): CancelablePromise<EprescriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/eprescriptions/{eprescription_id}/',
            path: {
                'eprescription_id': eprescriptionId,
            },
        });
    }
    /**
     * Cancel Eprescription
     * Cancel an eprescription via SÚKL ZrusitPredpis (soft cancel). Required Permission: cancel_eprescription
     * @returns EprescriptionDetailSchema OK
     * @throws ApiError
     */
    public static eprescriptionCancelEprescriptionDelete({
        eprescriptionId,
        requestBody,
    }: {
        eprescriptionId: string,
        requestBody: EprescriptionCancelSchema,
    }): CancelablePromise<EprescriptionDetailSchema> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/eprescriptions/{eprescription_id}/',
            path: {
                'eprescription_id': eprescriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change Eprescription
     * Change an existing eprescription (full update) and return the signing material. Required Permission: update_eprescription
     * @returns EprescriptionDraftSchema OK
     * @throws ApiError
     */
    public static eprescriptionChangeEprescriptionPut({
        eprescriptionId,
        requestBody,
    }: {
        eprescriptionId: string,
        requestBody: EprescriptionCreateSchema,
    }): CancelablePromise<EprescriptionDraftSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/eprescriptions/{eprescription_id}/',
            path: {
                'eprescription_id': eprescriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Slip
     * Download the eprescription slip PDF from SÚKL. Required Permission: get_eprescription_slip
     * @returns any OK
     * @throws ApiError
     */
    public static eprescriptionGetSlipGet({
        eprescriptionId,
    }: {
        eprescriptionId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/eprescriptions/{eprescription_id}/slip/',
            path: {
                'eprescription_id': eprescriptionId,
            },
        });
    }
}
